import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import green from '@material-ui/core/colors/green';
import { InputAdornment, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { connect } from 'react-redux';
import { searchManage } from '../../reducers/search';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '10px',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    //width: 200
  },
  formControl: {
    margin: theme.spacing.unit,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  padding5px: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '5px',
    margin: '10px',
  },
  cssGreen: {
    color: theme.palette.getContrastText(green[500]),
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  titlePanel: {
    backgroundColor: green[500],
    color: theme.palette.getContrastText(green[500]),
  },
  selectStyles: {
    input: (base) => ({
      ...base,
      color: theme.palette.text.primary,
      '& input': {
        font: 'inherit',
      },
    }),
  },
  txtBlack: {
    color: '#000000',
  },
  iconButton: { marginRight: '20px', padding: '2px' },
});

class RouteSelectManage extends Component {
  state = {
    value: [],
  };
  renderMenuItem = () => {
    let self = this;
    if (this.props.dashboard_route_select) {
      var menuItem = [...this.props.dashboard_route_select];
      menuItem.sort();
      return menuItem.map(function (value, index) {
        return (
          <MenuItem key={value} value={value}>
            <Checkbox
              checked={
                self.props.search_manage.route &&
                self.props.search_manage.route.indexOf(value) > -1
                  ? true
                  : false
              }
            />
            <ListItemText primary={value} />
          </MenuItem>
        );
      });
    } else return null;
  };
  onClearSelect = () => {
    this.setState({ value: [] });
    this.props.searchManage({
      ...this.props.search_manage,
      route: [],
    });
  };
  handleChange = (event) => {
    this.setState({ value: event.target.value });
    this.props.searchManage({
      ...this.props.search_manage,
      route: event.target.value,
    });
  };
  render() {
    const { classes } = this.props;
    return (
      <FormControl required fullWidth className={classes.textField}>
        <InputLabel
          shrink
          htmlFor='route-required'
          className={classes.txtBlack}
        >
          ROUTE
        </InputLabel>
        <Select
          multiple
          testing='select-route'
          name='route'
          value={
            this.props.search_manage.route ? this.props.search_manage.route : []
          }
          onChange={this.handleChange}
          renderValue={(selected) => selected.join(', ')}
          inputProps={{
            id: 'route-required',
          }}
          endAdornment={
            this.state.value &&
            this.state.value.length > 0 && (
              <InputAdornment position='end'>
                <IconButton
                  className={classes.iconButton}
                  aria-label='clear'
                  onClick={this.onClearSelect}
                >
                  <CloseIcon fontSize='small' />
                </IconButton>
              </InputAdornment>
            )
          }
        >
          {this.renderMenuItem()}
        </Select>
      </FormControl>
    );
  }
}
const mapStateToProps = function (state) {
  return {
    dashboard_route_select: state.dashboard.dashboard_route_select,
    search_manage: state.search.search_manage,
  };
};
const mapActionsToProps = {
  searchManage,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(RouteSelectManage));
